import React from "react";

const RTOCharges = ({ rtoCharges, leftPosition, topPosition }) => {
  return (
    <div
      className="details_tooltip_wrapper rto_charge_tooltip_wrapper rto-charges-tooltip"
      style={{ left: leftPosition, top: topPosition }}
    >
      <div className="x_panel">
        <div className="x_title">
          <h2 className="rto_charge_heading">Total RTO Charges</h2>
          <div className="clearfix"></div>
        </div>
        <div className="x_content">
          <div className="row">
            <div className="col-md-6 col-sm-6 pad-R5">
              <div className="form-group">
                <label className="label_text">Total Invoice</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    <ul className="rto_charge_details">
                      <li>
                        {rtoCharges.total_invoice !== ""
                          ? rtoCharges.total_invoice
                          : "--"}
                      </li>
                    </ul>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="form-group">
                <label className="label_text">Exc. tds & gst</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    <ul className="rto_charge_details">
                      <li>
                        {rtoCharges.total_charges !== ""
                          ? rtoCharges.total_charges
                          : "--"}
                      </li>
                    </ul>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RTOCharges;
